import { post, get, baseURL } from "@/utils/request";

// i18n API
export const getI18nList = (data: any) => post(`/common/i18n/keyMaps`, data);

// Get Activity data 
export const getActivityInformations = (params: any) => post(`/activity/info`, params);

// Get Activity List 
export const getActivityList = () => get(`/activity/activityList`);

export const getPWADomainInfo = () => get(`/pwaReward/domain/info`);